/**
 * Marketing → Telegram: guruhga bot qo‘shish havolalari.
 * Default: @addeordersbot (buyurtmalar / marketing bot).
 * Override: REACT_APP_TELEGRAM_MARKETING_BOT_USERNAME
 */
export function getMarketingTelegramBotUsername(): string {
  const raw =
    typeof process !== 'undefined' && process.env?.REACT_APP_TELEGRAM_MARKETING_BOT_USERNAME
      ? String(process.env.REACT_APP_TELEGRAM_MARKETING_BOT_USERNAME).trim()
      : '';
  if (raw) return raw.replace(/^@/, '');
  return 'addeordersbot';
}
